import { Loader } from '@sgme/ui';
import { QuoteInfoTable } from 'routes/essential-workspace/components/quote-panel/quote/info-table';

export function QuotePricingDetails() {
  return (
    <div className="flex-y py-0 gap-2 text-center quote-details-min-height">
      <div className="quote-pricing-container py-3">
        <Loader purpose="blinker" size="lg" />
      </div>
      <QuoteInfoTable />
    </div>
  );
}
